import { createSlice } from "@reduxjs/toolkit";

const initialState = {
//   selectedNoteType: "",
  loading: false,
  addpayerLoading: false,
//   loadingNote_Types: false,

allpayer: [],
alllistpayer:[]
//   noteTypes: [],
//   allNotesTypes: [],
//   fieldType: [],
//   notesAgainstTypes: []
};

export const payerState = createSlice({
  name: "payer",
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action?.payload
      };
    },

    setAddPayerLoading(state, action) {
      return {
        ...state,
        addpayerLoading: action?.payload
      };
    },

    setAllPayer(state, action) {
        return {
          ...state,
          loading: false,
          allpayer: action?.payload,
        //   addFacilityLoading: false
        };
      },

      setAllListPayer(state, action) {
        return {
          ...state,
          loading: false,
          alllistpayer: action?.payload,
        //   addFacilityLoading: false
        };
      },

      



    // Reset State
    reset() {
      return initialState;
    }
  }
});

export const {
  setLoading,
  setAddPayerLoading,
  setAllPayer,
  setAllListPayer,
} = payerState.actions;
export default payerState.reducer;
